import { render, staticRenderFns } from "./formulario_campo_paragrafo.vue?vue&type=template&id=2f1d31a8&scoped=true"
import script from "./formulario_campo_paragrafo.vue?vue&type=script&lang=js"
export * from "./formulario_campo_paragrafo.vue?vue&type=script&lang=js"
import style0 from "./formulario_campo_paragrafo.vue?vue&type=style&index=0&id=2f1d31a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1d31a8",
  null
  
)

export default component.exports